<template>
    <div class="base-header">
        <span class="base-header-logo">
          <img src="../../assets/images/logo.png" alt="">
        </span>
        <div class="base-header-right">
            <div v-if="!showSearchInput">
                <ul>
                    <li v-for="menu in dataList" :key="menu.id">
                        <a :href="handlerSwitchLanguage(language, 'url', menu)" target="_blank">
                            {{ handlerSwitchLanguage(language, 'name', menu) }}
                        </a>
                    </li>

                    <!-- <li>
                        <a href="javascript:void(0)" @click="setShowLoginPop(true)" v-if="!isLogin">登录/注册</a>
                        <el-button type="primary" icon="el-icon-user-solid" size="mini" @click="toUserCenter" round
                                   v-else>{{userInfo.name}}
                        </el-button>
                    </li> -->

                    <li>
                        <a href="http://stroke-society.mwcare.cn/en#/" v-if="language === 'zh'">En</a>
                        <a href="http://stroke-society.mwcare.cn/#/" v-else>中</a>
                    </li>

                    <li>
                        <a href="http://stroke-society.mwcare.cn/en#/" v-if="language === 'zh'">En</a>
                        <a href="http://stroke-society.mwcare.cn/#/" v-else>中</a>
                    </li>

                    <li><i class="el-icon-search" style="font-size:20px" @click="showSearchInput = true"></i></li>
                </ul>
            </div>
            <transition name="fade">
                <div class="base-header-search" v-if="showSearchInput">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-input v-model='value' class="base-header-input" placeholder="请输入关键字" maxlength="20"
                                      :autofocus="true" clearable="true">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearch" circle></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="showSearchInput = false" icon="el-icon-close" circle></el-button>
                        </el-form-item>
                        <!-- <el-form-item>
                          <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{dict[language].search}}</el-button>
                        </el-form-item>
                        <el-form-item>
                          <el-button @click="showSearchInput = false">{{dict[language].cancel}}</el-button>
                        </el-form-item> -->
                    </el-form>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import dict from '@/assets/json/dictionaries.json'
    import mixs from "@/mixs"
    import {getSwtopmenuList} from '@/http/request'

    export default {
        name: "BaseHeader",
        inject: ['language'],
        mixins: [mixs],
        data() {
            return {
                showSearchInput: false,
                value: '',
                dataList: [],
                dict
            }
        },
        computed: {
            ...mapState({
                isLogin: state => state.isLogin,
                userInfo: state => state.userInfo
            })
        },
        created() {
            this.getSwtopmenuList()
        },
        methods: {
            ...mapActions(['setShowLoginPop']),

            // 搜索
            handleSearch() {
                const key = this.value;
                if (!key) {
                    return
                }
                this.$store.dispatch("setSearchKey", key)
                this.showSearchInput = false

                if ("/query" === this.$route.path) {
                    return
                }

                this.showSearchInput = false;
                this.value = "";
                this.$router.push({
                    path: '/query'
                })
            },

            // query
            getSwtopmenuList() {
                getSwtopmenuList().then(({data}) => {
                    if (data.code === 0) {
                        this.dataList = data.data.list
                    }
                })
            },

            // 跳转个人中心
            toUserCenter() {
                this.$router.push('/userCenter')
            }
        }
    }
</script>

<style lang="less">
    .base-header {
        padding: 0 10px;
        margin-bottom: 0px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: sticky;
        top: 0;
        z-index: 9;
        pointer-events: none;
        background: #fff;

        .base-header-logo {
            width: 50px;
            display: block;
        }

        .base-header-right {
            pointer-events: initial;
            height: 60px;
            display: flex;
            flex: 1;
            justify-content: flex-end;
            position: relative;

            ul {
                li {
                    display: inline-block;
                    margin: 0 8px;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 60px;
                    cursor: pointer;

                    &:hover {
                        color: #409eff;
                    }

                    a {
                        color: #3F3F3F;
                    }
                }
            }

            .base-header-search {
                width: 320px;
                position: absolute;
                top: 15px;
                right: 0;
                z-index: 1000;
            }
        }
    }
</style>
